import * as SidebarAccordionActions from './sidebar-accordion.actions';
import type { SidebarAccordionState } from './sidebar-accordion.models';

const { SidebarAccordionActionsTypes } = SidebarAccordionActions;

type SidebarAccordionActionsFunctions = Omit<typeof SidebarAccordionActions, 'SidebarAccordionActionsTypes'>;
type ActionsResponses = ReturnType<SidebarAccordionActionsFunctions[keyof SidebarAccordionActionsFunctions]>;

const initialState: SidebarAccordionState = {
  currentScroll: 0
};

export default (state = initialState, action: ActionsResponses): SidebarAccordionState => {
  switch (action.type) {
    case SidebarAccordionActionsTypes.SET_CURRENT_SCROLL:
      return {
        ...state,
        currentScroll: action.payload
      };
    default:
      return state;
  }
};
